/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { LatitudeLongitude } from './LatitudeLongitude';
import {
    LatitudeLongitudeFromJSON,
    LatitudeLongitudeFromJSONTyped,
    LatitudeLongitudeToJSON,
    LatitudeLongitudeToJSONTyped,
} from './LatitudeLongitude';
import type { Hours } from './Hours';
import {
    HoursFromJSON,
    HoursFromJSONTyped,
    HoursToJSON,
    HoursToJSONTyped,
} from './Hours';
import type { LocationType } from './LocationType';
import {
    LocationTypeFromJSON,
    LocationTypeFromJSONTyped,
    LocationTypeToJSON,
    LocationTypeToJSONTyped,
} from './LocationType';

/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {LocationType}
     * @memberof Location
     */
    locationType: LocationType;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    distributionWarehouseBrand?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    businessName: string;
    /**
     * 
     * @type {Address}
     * @memberof Location
     */
    address: Address;
    /**
     * 
     * @type {Hours}
     * @memberof Location
     */
    hours: Hours;
    /**
     * 
     * @type {LatitudeLongitude}
     * @memberof Location
     */
    latitudeLongitude: LatitudeLongitude;
    /**
     * 
     * @type {Array<string>}
     * @memberof Location
     */
    accessorials: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    notes: string;
}



/**
 * Check if a given object implements the Location interface.
 */
export function instanceOfLocation(value: object): value is Location {
    if (!('locationType' in value) || value['locationType'] === undefined) return false;
    if (!('businessName' in value) || value['businessName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('hours' in value) || value['hours'] === undefined) return false;
    if (!('latitudeLongitude' in value) || value['latitudeLongitude'] === undefined) return false;
    if (!('accessorials' in value) || value['accessorials'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function LocationFromJSON(json: any): Location {
    return LocationFromJSONTyped(json, false);
}

export function LocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Location {
    if (json == null) {
        return json;
    }
    return {
        
        'locationType': LocationTypeFromJSON(json['locationType']),
        'distributionWarehouseBrand': json['distributionWarehouseBrand'] == null ? undefined : json['distributionWarehouseBrand'],
        'businessName': json['businessName'],
        'address': AddressFromJSON(json['address']),
        'hours': HoursFromJSON(json['hours']),
        'latitudeLongitude': LatitudeLongitudeFromJSON(json['latitudeLongitude']),
        'accessorials': json['accessorials'],
        'notes': json['notes'],
    };
}

  export function LocationToJSON(json: any): Location {
      return LocationToJSONTyped(json, false);
  }

  export function LocationToJSONTyped(value?: Location | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationType': LocationTypeToJSON(value['locationType']),
        'distributionWarehouseBrand': value['distributionWarehouseBrand'],
        'businessName': value['businessName'],
        'address': AddressToJSON(value['address']),
        'hours': HoursToJSON(value['hours']),
        'latitudeLongitude': LatitudeLongitudeToJSON(value['latitudeLongitude']),
        'accessorials': value['accessorials'],
        'notes': value['notes'],
    };
}

